import Loader from "../utils/Loader";
import { useState, useRef, useEffect } from 'react';
import useNotifications from "../hooks/useNotifications";
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import NotificationMeta from "./NotificationMeta";
import NetworkStatusIndicator from "./NetworkStatusIndicator";
import MobileInfoPanel from "./MobileInfoPanel";
import moment from "moment";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import { useNavigate, Link } from "react-router-dom";


const VisitorHeader = () => {
    const navigate = useNavigate();

    const [isLoading, setLoader] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
    const notificationRef = useRef(null);
    const notificationMobileRef = useRef(null);
    const marqueeRef = useRef(null);

    // Exhibition From Date
    const dateString = sessionStorage.getItem('exhibitionDateFrom');
    const dateStringMoment = moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY')
    const dateObject = new Date(dateStringMoment);
    const fromDay = dateObject.getDate();
    const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
    const fromYear = dateObject.getFullYear();
    const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;
    console.log('dateString', dateString)
    console.log('dateStringMoment', dateStringMoment)
    console.log('dateObject', dateObject)

    // Exhibition to Date
    const dateString1 = sessionStorage.getItem('exhibitionDateTo');
    const dateString1Moment = moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY')
    const dateObject1 = new Date(dateString1Moment);
    const toDay = dateObject1.getDate();
    const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
    const toYear = dateObject1.getFullYear();
    const toDate = `${toDay} ${toMonth} ${toYear}`;

    // Exhibition Logo File Path
    const logoPath = sessionStorage.getItem('sessionLogoPath')
    const ExhibitionEmail = JSON.parse(sessionStorage.getItem('sessionExhibitionEmail'))
    const ExhibitionMobileNo = JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo'))

    // Exhibition Address
    const address = sessionStorage.getItem('exhibitionAddress')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const location = window.location.hash || window.location.pathname;
    const isVisitorRegistration = location.toLowerCase().includes("visitorregistration");

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    useEffect(() => {
        function handleClickOutside(event) {
            const inDesktop = notificationRef.current && notificationRef.current.contains(event.target);
            const inMobile = notificationMobileRef.current && notificationMobileRef.current.contains(event.target);
            if (!inDesktop && !inMobile) {
                setShowNotifications(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}

            {isMobileMenuOpen && (
                <div
                    className="mobile-menu-overlay exhibitor-mobile-overlay"
                    onClick={closeMobileMenu}
                ></div>
            )}


            <div
                className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}
            >
                <MobileInfoPanel
                    name={sessionStorage.getItem("sessionExhibitionName") || "INDIA ITME 2026"}
                    welcome=""
                    onClose={closeMobileMenu}
                    notifications={!isVisitorRegistration ? notifications : undefined}
                    onNotificationClick={(n) => { openPreview(n.id); closeMobileMenu(); }}
                    onMarkAllRead={markAllRead}
                    onViewAll={() => { openDrawer(); closeMobileMenu(); }}
                    details={{
                        dates: `${sessionStorage.getItem("exhibitionDateFrom") || ''} - ${sessionStorage.getItem("exhibitionDateTo") || ''}`,
                        location: address,
                    }}
                    assistance={{ phones: ExhibitionMobileNo || [], emails: ExhibitionEmail || [] }}
                >
                    {/* Organiser card */}
                    <div className="mip-card">
                        <div className="mip-list d-flex align-items-center gap-3 py-3">
                            <img src="../images/itme-right-logo.png" alt="logo" style={{ height: '52px', objectFit: 'contain' }} />
                            <div>
                                <div className="mip-value mip-value-strong">INDIA ITME SOCIETY</div>
                                <div className="mip-label" style={{ textTransform: 'none', letterSpacing: 0 }}>Empowering Textiles through Trade and Technology</div>
                            </div>
                        </div>
                    </div>
                </MobileInfoPanel>
            </div>

            <div className="app-header header sticky app-heder-with-logo visitor-header-light">
                <div className="container-fluid main-container pe-2">
                    <div className="d-flex mt-1 mt-lg-0">
                        {/* <a className="logo-horizontal " href="index.html">
                            <img
                                src={logoPath} className="header-brand-img desktop-logo" alt="logo" />
                        </a> */}
                        <div className="d-flex flex-grow-1 align-items-center">
                            <div className="side-header top-logo-almnt visitor-header-logo d-flex align-items-center justify-content-center" style={{ padding: '0', margin: '0' }}>
                                <a href="index.html">
                                    <img src={logoPath} alt="logo" className="visitor-header-logo-img" />
                                </a>
                            </div>

                            {/* <p className=" header-assistance text-white">
                                     For Assistance
                                     <br>
                                     </br>
                                     {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                         {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                     </>
                                     )) : null}
                                     <br>
                                     </br>
                                     {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                         <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                     )) : null}
                                 </p> */}


                            {/* <div class="right-logo">
                <p className='right-logo-text' style={{ top: '20px' }}>Owned and Organised by</p>
                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
              </div> */}


                            {/* Desktop info: date + venue, then assistance contacts, each with an icon tile */}
                            <div className="vh-info d-none d-xl-flex" style={{ justifyContent: 'flex-start', paddingLeft: 12 }}>
                                {/* Inline alignment: both lines start at the same left edge whatever else is in the cascade */}
                                <div className="vh-block" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                    <div className="vh-row" style={{ justifyContent: 'flex-start', width: '100%' }}>
                                        <span className="vh-icon"><i className="fa fa-calendar"></i></span>
                                        <strong className="vh-date">{fromDate} - {toDate}</strong>
                                    </div>
                                    <div className="vh-row" style={{ justifyContent: 'flex-start', width: '100%' }}>
                                        <span className="vh-icon"><i className="fa fa-map-marker"></i></span>
                                        <span className="vh-address">
                                            {address && address.indexOf(',') > -1 ? (
                                                <>
                                                    <strong>{address.slice(0, address.indexOf(',') + 1)}</strong>
                                                    {address.slice(address.indexOf(',') + 1)}
                                                </>
                                            ) : address}
                                        </span>
                                    </div>
                                </div>

                                <span className="vh-divider"></span>

                                {/* Two lines only (label, then phone · email) so it clears the marquee */}
                                <div className="vh-block">
                                    <div className="vh-row">
                                        <span className="vh-icon vh-icon-round"><i className="fa fa-headphones"></i></span>
                                        <div>
                                            <div className="vh-label">For Assistance</div>
                                            <div className="vh-contact">
                                                <strong className="vh-phone">
                                                    {ExhibitionMobileNo && ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.join(', ') : null}
                                                </strong>
                                                {ExhibitionEmail && ExhibitionEmail.length > 0 && (
                                                    <span className="vh-email">
                                                        <i className="fa fa-envelope-o"></i>
                                                        {ExhibitionEmail.map((data, i) => (
                                                            <a key={i} href={`mailto:${data}`}>{data}{i != ExhibitionEmail.length - 1 ? ' / ' : ''}</a>
                                                        ))}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Kept outside .right-logo: that box is absolute and white, so the pill stretched it over the marquee */}
                            {/* hdr-actions: same circle icons as every header */}
                            <div className="header-network-slot d-none d-xl-flex hdr-actions">
                                {/* Desktop Network Connectivity */}
                                <NetworkStatusIndicator compact />

                                {/* Desktop Notification Bell */}
                                {!isVisitorRegistration && (
                                    <div className="notification-bell-wrapper" ref={notificationRef}>
                                        <i
                                            className="fa fa-bell hdr-icon-btn"
                                            onClick={() => setShowNotifications(!showNotifications)}
                                            title="Notifications"
                                        ></i>
                                        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                                        {showNotifications && (
                                            <div className="notification-dropdown shadow">
                                                <div className="notification-dropdown-header">
                                                    <span>Notifications</span>
                                                    {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                                </div>
                                                {notifications.length === 0 ? (
                                                    <div className="notification-empty">No notifications</div>
                                                ) : notifications.slice(0, 3).map(n => (
                                                    <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                                        <span className={`notification-item-icon ${n.type}`}>
                                                            {n.initial}
                                                        </span>
                                                        <div className="notification-item-content">
                                                            <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                                                            <NotificationMeta notification={n} />
                                                            {n.time && <div className="notification-item-time">{n.time}</div>}
                                                        </div>
                                                        <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                                    </div>
                                                ))}
                                                <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                                            </div>
                                        )}
                                    </div>
                                )}                            </div>

                            <div className="right-logo d-none d-xl-block">
                                <p className='right-logo-text' style={{ top: '20px', color: 'white' }}>Owned and Organised by</p>
                                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                            </div>

                        </div>
                        {/* <p className="header-logo-name text-white" >{fromDate} - {toDate} <br></br>
                            {address}
                        </p> */}
                        {/* <p className="header-logo-name text-white">
                            {fromDate} - {toDate}
                            <br />
                            {address && (
                                <>
                                    {address.slice(0, 45)}
                                    <br />
                                    {address.slice(45)}
                                </>
                            )}
                        </p> */}


                        {/* <div class="right-logo">
                            <p className='right-logo-text text-nowrap text-white' style={{ top: '8px' }}>Owned and Organised by</p>
                            <p className=" header-assistance text-white text-nowrap">
                                For Assistance &nbsp;
                                {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>
                                    {data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}
                                </>
                                )) : null}
                                <br>
                                </br>
                                {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (
                                    <a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>
                                )) : null}
                            </p>
                            <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
                        </div> */}

                    </div>
                </div>
                {/* Absolute Marquee at the bottom of the header */}
                <div className="marquee-text" style={{ position: 'absolute', bottom: '-4px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
                    <marquee
                        behavior="scroll"
                        direction="left"
                        scrollamount="5"
                        ref={marqueeRef}
                        onMouseOver={() => marqueeRef.current?.stop()}
                        onMouseOut={() => marqueeRef.current?.start()}
                        style={{ pointerEvents: 'auto', marginBottom: '0' }}
                    >
                        <b>Disclaimer and Ownership:</b> {disclaimer}
                    </marquee>
                </div>

                <div className="mobile-toggle exhibitor-mobile-toggle d-xl-none pe-1 d-flex hdr-actions">
                    {/* Mobile Network Connectivity */}
                    <NetworkStatusIndicator compact />

                    {/* Mobile Notification Bell */}
                    {!isVisitorRegistration && (
                        <div className="notification-bell-wrapper" ref={notificationMobileRef}>
                            <i
                                className="fa fa-bell hdr-icon-btn"
                                onClick={() => setShowNotifications(!showNotifications)}
                                title="Notifications"
                            ></i>
                            {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                            {showNotifications && (
                                <div className="notification-dropdown shadow">
                                    <div className="notification-dropdown-header">
                                        <span>Notifications</span>
                                        {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                    </div>
                                    {notifications.length === 0 ? (
                                        <div className="notification-empty">No notifications</div>
                                    ) : notifications.map(n => (
                                        <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                            <span className={`notification-item-icon ${n.type}`}>
                                                {n.initial}
                                            </span>
                                            <div className="notification-item-content">
                                                <div className="notification-item-title">{n.title}</div>
                                                <NotificationMeta notification={n} />
                                                <div className="notification-item-time">{n.time}</div>
                                            </div>
                                            <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                        </div>
                                    ))}
                                    <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                                </div>
                            )}
                        </div>
                    )}
                    <button
                        onClick={toggleMobileMenu}
                        className="exhibitor-menu-toggle-btn"
                    >
                        <span className="exhibitor-menu-toggle-bar"></span>
                        <span className="exhibitor-menu-toggle-bar"></span>
                        <span className="exhibitor-menu-toggle-bar"></span>
                    </button>
                </div>
            </div>


            <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
            <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
        </>
    )
}

export default VisitorHeader;